var MenuEvent = {
	UPDATE_MENU: 'updateMenu'
};
module.exports = MenuEvent;